import { render, staticRenderFns } from "./HomeworkCheck.vue?vue&type=template&id=6082757b&"
import script from "./HomeworkCheck.vue?vue&type=script&lang=js&"
export * from "./HomeworkCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports